import * as React from 'react';

// Mui
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem'; // Usaremos MenuItem para todos los enlaces
import DnsTwoToneIcon from '@mui/icons-material/DnsTwoTone';
import { Link } from 'react-router-dom';
import { ListItemIcon, ListItemText, Tooltip, useTheme } from '@mui/material'; // Quitamos List y ListItem

// componentes
import { SelectTheme } from './SelectTheme';

// redux
import { useSelector } from 'react-redux';
import { IconMap } from './IconMap';
import { breakPoints } from '../helpers/breakPoint';


export const MenuBar = ({ handle, tema, menus }) => {

    const logged = useSelector(state => state.loggedStore.value)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { setTheme, theme } = tema;
    const themeScheme = useTheme()

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const firstCapital = (str) => str[0].toUpperCase() + str.slice(1)

    const currentMenu = [
        menus.noLogged, // Índice 0 (logged.state = false)
        menus.logged,   // Índice 1 (logged.state = true)
    ][logged?.state ? 1 : 0];


    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{ padding: '0vh' }}
            >
                <DnsTwoToneIcon fontSize='large' />
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            // MenuListProps={{
            //     'aria-labelledby': 'basic-button',
            // }}
            >
                {/* 1. Elementos de navegación (usando MenuItem) */}
                {
                    currentMenu.map((label, id) => (
                        <MenuItem
                            key={`${label}_${id}`}
                            // Usamos component={Link} para navegación
                            component={Link}
                            onClick={() => setAnchorEl(null)}
                            to={`/${label.replace(/\s+/g, '')}`}
                            sx={{
                                color: themeScheme.palette.text.primary,
                                marginBlock: '1vh',
                                width: breakPoints(['40vw', '40vw', '65vw']),
                                paddingLeft: breakPoints(['5vw', '5vw', '10vw'])
                            }}
                        >
                            <Tooltip title={label} placement="right" disableHoverListener={open}>
                                <ListItemIcon sx={{ minWidth: '40px' }}>{IconMap[label]}</ListItemIcon>
                            </Tooltip>
                            {/* Solo muestra el texto si el menú está abierto */}
                            {open && <ListItemText primary={firstCapital(label)} />}
                        </MenuItem>
                    ))
                }

                {/* 2. Botón de Cerrar Sesión (solo si está logueado) */}
                {
                    logged.state &&
                    <MenuItem
                        sx={{
                            color: themeScheme.palette.text.primary,
                            cursor: 'pointer',
                            marginBlock: '1vh'
                        }}
                        onClick={() => { setAnchorEl(null); handle(); }}
                    >
                        <Tooltip
                            title={'salir'}
                            placement="right"
                            disableHoverListener={open}
                        >
                            <ListItemIcon sx={{ minWidth: '40px' }}>{IconMap['salir']}</ListItemIcon>
                        </Tooltip>
                        {
                            open && <ListItemText primary={firstCapital('salir')} />
                        }
                    </MenuItem>
                }

                {/* 3. Selector de Tema */}
                <MenuItem onClick={(e) => e.stopPropagation()} disableRipple={true} sx={{ '&:hover': { backgroundColor: 'transparent' } }}>
                    <SelectTheme setValue={setTheme} mode={theme} />
                </MenuItem>

            </Menu>
        </div >
    );
}